import styled from 'styled-components';
import tw from 'twin.macro';
import { motion } from 'framer-motion';
import Sticky from '../../styled components/Sticky';
import { Body, Title } from '../../styled components/Typography';

export const TabNavigationTabList = styled.ul(() => [tw`relative p-8 pl-0 pr-0`]);
export const TabNavigationTabListText = styled(Body).attrs(() => ({
  as: 'a'
}))(({ selected }) => [
  tw`flex p-8 pl-16 pr-16 w-full cursor-pointer hover:bg-silver-lighten-15 active:bg-silver-base`,
  selected && tw`bg-blue-lighten-30 hover:bg-blue-lighten-30 active:bg-blue-lighten-40`
]);

/* Specific for LARGE devices */
export const TabNavigationLargeContainerAnimation = styled(motion.div)(() => [
  tw`relative flex p-16 bg-silver-lighten-30 h-full`
]);
export const TabNavigationLargeTabList = styled.div(() => [
  tw`relative mr-16 bg-white`,
  'width: 250px;',
  'z-index: 80;'
]);
export const TabNavigationLargeContent = styled.div(() => [tw`w-3/4 bg-white min-w-0`]);

/* h3 className: mb-px necessary for negative top margin for treeheader */
export const TabNavigationLargeTabTitle = styled(Title).attrs(() => ({
  as: 'h3'
}))(() => [tw`p-8 mb-px text-center border-b border-solid border-silver-lighten-15`]);
export const TabNavigationLargeSticky = styled(Sticky).attrs(({ $stickyTopPosition }) => ({
  $top: $stickyTopPosition
}))(({ $stickyTopPosition }) => [
  tw`overflow-auto`,
  `max-height: calc(100vh - ${$stickyTopPosition}px);`
]);
export const TabNavigationLargeStickyTabTitle = styled(Sticky).attrs(
  ({ $stickyTopPosition }) => ({
    $zIndex: 70,
    $top: $stickyTopPosition
  })
)(() => [tw`bg-white`]);

/* Specifig for SMALL devices */
export const TabNavigationSmallContent = styled.div(() => ['z-index: 70;']);
export const TabNavigationSmallList = styled.div(() => [tw`relative`]);
/* h2 className: mb-px necessary for negative top margin for treeheader */
export const TabNavigationSmallTabTitle = styled(Body).attrs(() => ({
  as: 'h2'
}))(() => [
  tw`p-8 pl-16 pr-16 mb-px w-full bg-white text-center border-b border-solid border-silver-lighten-15`
]);
export const TabNavigationSmallTabButtonContainer = styled.div(() => [
  tw`absolute right-0 top-0 mt-2 mr-16`
]);
